<template>
  <Loader v-if="loader" />
  <div class="card p-3">
    <div class="grid">
      <div class="col-12 lg:col-3">
        <label>Tipo fornitura</label>
        <Dropdown v-model="selectedTypeFornitura" :options="typesFornitura" optionLabel="name" optionValue="name"
          class="inputfield w-full" />
      </div>
      <div class="col-12 lg:col-3">
        <label>Agente</label>
        <Dropdown v-model="selectedAgente" :options="agenti" optionLabel="name" optionValue="name"
          :filter="true" filterBy="name" placeholder="Cerca agente..." class="inputfield w-full" />
      </div>
      <div class="col-12 lg:col-3">
        <label>Cessati al e prima del</label>
        <Calendar v-model="selectedDate" selectionMode="range" :manualInput="false" dateFormat="dd-mm-yy"
          class="inputfield w-full" />
      </div>
      <div class="col-12 lg:col-3">
        <label>Codice POD/PDR</label>
        <InputText v-model="codeFornitura" placeholder="Inserisci POD o PDR..." class="inputfield w-full" />
      </div>
      <div class="col-12 lg:col-6 flex align-items-end gap-2">
        <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" class="search-btn" />
        <Button 
          label="Invia Template" 
          @click="exportSelectedResults" 
          icon="pi pi-download" 
          iconPos="left" 
          class="export-all-btn "
          :disabled="!hasSelectedAccordions"
        />
        <Button 
          label="Esporta Totale Excel" 
          @click="exportToXLSX" 
          icon="pi pi-file-excel" 
          iconPos="left" 
          class="export-xlsx-btn "
          :disabled="!hasResults"
        />
        <input 
          ref="fileInputImportCmorLavorate"
          type="file"
          accept=".csv"
          multiple
          style="display:none"
          @change="onFileChangeImportCmorLavorate"
        />
        <Button 
          label="Importa File Cmor Lavorate" 
          @click="triggerImportCmorLavorate" 
          icon="pi pi-upload" 
          iconPos="left" 
          class="import-xlsx-btn"
        />
        <Button 
          label="Info Cmor Lavorate" 
          @click="openInfoCmorLavorateDialog" 
          icon="pi pi-info-circle" 
          iconPos="left" 
          class="info-xlsx-btn"
        />
        <Button 
          label="Genera Template Annullamenti" 
          @click="openAnnullamentiDialog" 
          icon="pi pi-times-circle" 
          iconPos="left" 
          class="annullamenti-btn"
        />
      </div>
    </div>
  </div>


  <div v-show="selectedItems.length > 0" class="btn-selected mb-2">
    <Button @click="generateAndSendFileCmor" class="p-button-warning p-3 m-1" style="min-width:200px">
      Invia template cmor ({{ selectedItems.length }}) <i class="pi pi-send ml-5"></i>
    </Button>
    <Button @click="dialogBeforePecSent = !dialogBeforePecSent" class="p-button-secondary p-3 m-1"
      style="min-width:200px">
      Invia pec messa in mora ({{ selectedItems.length }}) <i class="pi pi-send ml-5"></i>
    </Button>
  </div>

  <Accordion v-if="Object.keys(items).length > 0" :multiple="true" v-model:activeIndex="activeTabIndex" lazy>
    <AccordionTab v-for="(objs, type) in items" :key="type">
      <template #header>
        <div class="flex align-items-center gap-2">
          <Checkbox 
            v-model="selectedAccordions[type]" 
            class="mr-2"
            :binary="true" 
            @change="updateAccordionSelection"
            @click.stop
          />
          <span>{{ type.toUpperCase() }}</span>
        </div>
      </template>
      <Accordion :multiple="true" lazy>
        <AccordionTab v-for="(obj, year) in objs" :key="year">
          <template #header>
            <div class="flex align-items-center gap-2">
              <Checkbox 
                v-model="selectedYears[`${type}-${year}`]" 
                class="mr-2"
                :binary="true" 
                @change="updateYearSelection"
                @click.stop
              />
              <span>{{ year }}</span>
            </div>
          </template>
          <Accordion :multiple="true" lazy>
            <AccordionTab v-for="(item, month) in obj" :key="month">
              <template #header>
                <div class="flex align-items-center gap-2">
                  <Checkbox 
                    v-model="selectedMonths[`${type}-${year}-${month}`]"
                    class="mr-2"
                    :binary="true" 
                    @change="updateMonthSelection"
                    @click.stop
                  />
                  <span>{{ (moment().month(month).locale('it').format('MMMM')).toUpperCase() }}</span>
                </div>
              </template>

              <div v-if="item.some(el => !el.pec)">
                <Message severity="warn" class="bg-bluegray-100">
                  Attenzione alcune forniture non hanno indirizzo pec
                </Message>
              </div>

              <div v-if="item.some(el => el.saldo == 0 && el.data_invio_cmor_template > '')">
                <Message severity="info" class="bg-blue-300">
                  Alcune forniture saldate e inviato template
                </Message>
              </div>



              <div class="table-cmor">
                <DataTable :value="item" v-model:selection="selectedItems" :paginator="true" :rows="50"
                  :filters="filters" v-model:expandedRows="expandedRows" :rowClass="rowClass"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 50, 200]" dataKey="id" responsiveLayout="scroll"
                  currentPageReportTemplate="{first} a {last} di {totalRecords}">
                  <template #header>
                    <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                      <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                      </span>
                    </div>
                  </template>
                  <template #empty>
                    <div class="text-center">Nessun dato trovato.</div>
                  </template>
                  <Column :expander="true" headerStyle="width: 3rem" />
                  <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                  <Column header="" headerStyle="width: 3rem">
                    <template #body="{ data }">
                      <i v-if="data.caso_specifico_consumo === true" 
                         class="pi pi-exclamation-triangle" 
                         v-tooltip.top="'Manca dei requisiti'"
                         style="color: #f59e0b; font-size: 1.2rem; cursor: help;"></i>
                    </template>
                  </Column>
                  <Column field="code" header="Fornitura" :sortable="true"></Column>
                  <Column field="cliente" header="Cliente" :sortable="true"></Column>
                  <!-- <Column field="totale_fattura" header="Tot Fatture" :sortable="true">
                    <template #body="{ data }">
                      {{ data.totale_fattura.toFixed(2) }}
                    </template>
                  </Column> -->
                  <!-- <Column field="pagato" header="Tot Pagato" :sortable="true">
                    <template #body="{ data }">
                      {{ data.pagato.toFixed(2) }}
                    </template>
                  </Column> -->
                  <Column field="saldo" header="Tot saldo" :sortable="true">
                    <template #body="{ data }">
                      {{ data.saldo.toFixed(2) }}
                    </template>
                  </Column>
                  <!-- <Column field="data_fine" header="Data Inizio" :sortable="true" style="min-width:110px">
                    <template #body="{ data }">
                      {{ formatDate(data.data_inizio) }}
                    </template>
                  </Column> -->
                  <Column field="data_fine" header="Data Fine" :sortable="true" style="min-width:110px">
                    <template #body="{ data }">
                      {{ formatDate(data.data_fine) }}
                    </template>
                  </Column>
                  <Column field="data_invio_messa_in_mora" header="Data Invio MessainMora" :sortable="true">
                    <template #body="{ data }">
                      {{ formatDate(data.data_invio_messa_in_mora) }}
                    </template>
                  </Column>
                  <Column field="data_invio_cmor_template" header="Data Invio Cmor" :sortable="true">
                    <template #body="{ data }">
                      {{ formatDate(data.data_invio_cmor_template) }}
                    </template>
                  </Column>
                  <!-- <Column field="cc" header="CC" :sortable="true"></Column>
                  <Column field="udd" header="udd" :sortable="true"></Column> -->

                  <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
                  <Column field="piva" header="P.iva" :sortable="true"></Column>
                  <Column field="codfis" header="C.Fiscale" :sortable="true"></Column>
                  <!-- <Column field="type_client" header="Tipo Cliente" :sortable="true"></Column> -->
                  <!-- <Column field="comune" header="Comune" :sortable="true"></Column> -->
                  <!-- <Column field="indirizzo" header="Indirizzo" :sortable="true"></Column> -->
                  <Column field="email" header="Email" :sortable="true"></Column>
                  <Column field="pec" header="Pec" :sortable="true"></Column>
                  <!-- <Column field="offerta" header="Offerta" :sortable="true"></Column> -->
                  <!-- <Column field="pagamento" header="Pagamento" :sortable="true"></Column> -->
                  <!-- <Column field="fatturazione" header="Fatturazione" :sortable="true"></Column> -->
                  <!-- <Column field="contratto" header="Contratto" :sortable="true"></Column> -->
                  <Column field="agente" header="Agente" :sortable="true"></Column>
                  <Column field="udd" header="Udd" :sortable="true"></Column>
                  <Column field="udd" header="Nell'ultimo anno udd con">
                    <template #body="{ data }">
                      <span v-if="'id' in data.rcus">
                        {{ data.rcus.udd }} - {{ formatDate(data.rcus.data_fine) }}
                      </span>
                    </template>
                  </Column>
                  <template #expansion="slotProps">
                    <div class="dettaglio" style="width:900px">
                      <h5>Dettaglio</h5>
                      <DataTable :value="slotProps.data.details">
                        <Column field="numero" header="numero" sortable></Column>
                        <Column field="data_emissione" header="Data emissione" sortable>
                          <template #body="{ data }">
                            {{ formatDate(data.data_emissione) }}
                          </template>
                        </Column>
                        <Column field="data_scadenza" header="Data scadenza" sortable>
                          <template #body="{ data }">
                            {{ formatDate(data.data_scadenza) }}
                          </template>
                        </Column>
                        <Column field="totale_fattura" header="Tot.Fattura" sortable>
                          <template #body="{ data }">
                            {{ data.totale_fattura.toFixed(2) }}
                          </template>
                        </Column>
                        <Column field="pagato" header="Tot.Pagato" sortable>
                          <template #body="{ data }">
                            {{ data.pagato.toFixed(2) }}
                          </template>
                        </Column>
                        <Column field="saldo" header="Tot.Saldo" sortable>
                          <template #body="{ data }">
                            {{ data.saldo.toFixed(2) }}
                          </template>
                        </Column>
                      </DataTable>
                    </div>
                  </template>
                </DataTable>
              </div>


            </AccordionTab>
          </Accordion>
        </AccordionTab>
      </Accordion>
    </AccordionTab>
  </Accordion>

  <Dialog header="Check Invii Pec" v-model:visible="dialogBeforePecSent"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }" :modal="true">
    <div class="w-full">
      <DataTable :value="selectedItems" responsiveLayout="scroll">
        <Column field="code" header="Fornitura" :sortable="true"></Column>
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column field="pec" header="Contatto" :sortable="true"></Column>
      </DataTable>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogBeforePecSent = false" class="p-button-text" />
      <Button label="Invia" icon="pi pi-check" @click="generateAndSendPecMessaInMora"
        class="p-button-text p-button-primary" />
    </template>
  </Dialog>


  <Dialog header="Controllo Invii Pec" v-model:visible="dialogCheckPecSent"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }">
    <div class="w-full">
      <DataTable :value="report" responsiveLayout="scroll">
        <Column field="code" header="Fornitura" :sortable="true"></Column>
        <Column field="contact" header="Contatto" :sortable="true"></Column>
        <Column field="success" header="Inviata" :sortable="true">
          <template #body="{ data, field }">
            <span v-if="data[field] == true" class="text-green-400">SI</span>
            <span v-else class="text-orange-400">NO</span>
          </template>
        </Column>
      </DataTable>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogCheckPecSent = false" class="p-button-text" />
    </template>
  </Dialog>

  <Dialog header="Conferma Esportazione" v-model:visible="dialogConfirmExport"
    :breakpoints="{ '960px': '50vw', '640px': '90vw' }" :style="{ width: '40vw' }" :modal="true">
    <div class="flex align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem; color: var(--orange-500)"></i>
      <span class="text-lg">
        Vuoi esportare tutti i <strong>{{ exportItemsCount }}</strong> risultati della ricerca?
      </span>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" @click="dialogConfirmExport = false" class="p-button-text" />
      <Button label="Conferma" icon="pi pi-check" @click="confirmExport" class="p-button-success" />
    </template>
  </Dialog>

  <Dialog :header="`Info CMOR Lavorate - ${infoCmorLavorateType === 'richiesta' ? 'Richiesta' : 'Risposta'}`" v-model:visible="dialogInfoCmorLavorate"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '80vw' }" :modal="true">
    <div class="w-full">
      <div v-if="infoCmorLavorateData && infoCmorLavorateData.length > 0">
        <div class="mb-3">
          <span class="font-bold text-lg">Totale record: {{ infoCmorLavorateTotalRecords }}</span>
        </div>
        <Accordion :multiple="true" v-model:activeIndex="infoCmorActiveIndexes" @tab-open="onInfoCmorTabOpen">
          <AccordionTab v-for="(monthData, index) in infoCmorLavorateData" :key="index">
            <template #header>
              <span class="font-bold">{{ monthData.mese_nome }} {{ monthData.anno }} ({{ monthData.count }} record)</span>
            </template>
            <div v-if="loadingMonthRecords[`${monthData.anno}-${monthData.mese}`]" class="text-center p-4">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              <p class="mt-2">Caricamento record in corso...</p>
            </div>
            <DataTable v-else :value="monthData.records || []" responsiveLayout="scroll" :paginator="true" :rows="20"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              :rowsPerPageOptions="[20, 50, 100]">
              <Column field="piva_utente" header="PIVA Utente" :sortable="true"></Column>
              <Column field="cp_utente" header="CP Utente" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'risposta'" field="cp_gestore" header="CP Gestore" :sortable="true"></Column>
              <Column field="cod_pod" header="Cod POD" :sortable="true"></Column>
              <Column field="cod_pdr" header="Cod PDR" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="cf" header="CF" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="piva" header="PIVA" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="cmor" header="CMOR" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="data_switching" header="Data Switching" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_switching) }}
                </template>
              </Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="data_invio" header="Data Invio" :sortable="true">
                <template #body="{ data }">
                  {{ formatDate(data.data_invio) }}
                </template>
              </Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="identificativi_fatture_fi" header="Identificativi Fatture FI" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'richiesta'" field="importi_fatturati_fi" header="Importi Fatturati FI" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'risposta'" field="motivazione" header="Motivazione" :sortable="true"></Column>
              <Column v-if="infoCmorLavorateType === 'risposta'" field="data_invio" header="Data Invio" :sortable="true"></Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
      </div>
      <div v-else class="text-center p-4">
        <i class="pi pi-info-circle" style="font-size: 2rem; color: var(--text-color-secondary)"></i>
        <p class="mt-3">Nessun dato disponibile</p>
      </div>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogInfoCmorLavorate = false" class="p-button-text" />
    </template>
  </Dialog>

  <Dialog header="Seleziona Tipo Info" v-model:visible="dialogSelectInfoType"
    :breakpoints="{ '960px': '50vw', '640px': '90vw' }" :style="{ width: '40vw' }" :modal="true">
    <div class="flex flex-column align-items-center justify-content-center gap-4 p-4">
      <p class="text-lg">Seleziona il tipo di informazioni da visualizzare:</p>
      <div class="flex gap-1 w-full justify-content-between">
        <Button 
          label="Richiesta" 
          @click="selectInfoType('richiesta')" 
          icon="pi pi-file" 
          iconPos="left" 
          class="flex-2"
          style="min-width: 300px"
        />
        <Button 
          label="Risposta" 
          @click="selectInfoType('risposta')" 
          icon="pi pi-file" 
          iconPos="left" 
          class="flex-2"
          style="min-width: 300px"
        />
      </div>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" @click="dialogSelectInfoType = false" class="p-button-text" />
    </template>
  </Dialog>

  <Dialog header="Seleziona Tipo Import" v-model:visible="dialogSelectImportType"
    :breakpoints="{ '960px': '50vw', '640px': '90vw' }" :style="{ width: '40vw' }" :modal="true">
    <div class="flex flex-column align-items-center justify-content-center gap-4 p-4">
      <p class="text-lg">Seleziona il tipo di file da importare:</p>
      <div class="flex gap-1 w-full justify-content-between">
        <Button 
          label="Importa Richiesta" 
          @click="selectImportType('richiesta')" 
          icon="pi pi-file-upload" 
          iconPos="left" 
          class="flex-2"
          style="min-width: 300px"
        />
        <Button 
          label="Importa Risposta" 
          @click="selectImportType('risposta')" 
          icon="pi pi-file-upload" 
          iconPos="left" 
          class="flex-2"
          style="min-width: 300px"
        />
      </div>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" @click="dialogSelectImportType = false" class="p-button-text" />
    </template>
  </Dialog>

  <Dialog header="Importa File Risposta" v-model:visible="dialogInsertDataInvio"
    :breakpoints="{ '960px': '50vw', '640px': '90vw' }" :style="{ width: '40vw' }" :modal="true">
    <div class="flex flex-column gap-4 p-4">
      <p class="text-lg">Seleziona i file CSV da importare:</p>
      <p class="text-sm">NB: La data deve essere inserita nel formato gg/mm/aaaa nella colonna P del file di Risposta.</p>
      <div class="flex flex-column gap-2">
        <input 
          ref="fileInputDialog"
          type="file"
          accept=".csv"
          multiple
          style="display:none"
          @change="onFileSelectedInDialog"
        />
        <Button 
          label="Carica File" 
          icon="pi pi-upload" 
          @click="triggerFileInputDialog" 
          class="p-button-primary"
        />
        <div v-if="selectedFilesInDialog.length > 0" class="mt-2">
          <p class="font-semibold mb-2">File selezionati: {{ selectedFilesInDialog.length }}</p>
          <ul class="list-none p-0">
            <li v-for="(file, index) in selectedFilesInDialog" :key="index" class="mb-1">
              <i class="pi pi-file mr-2"></i>{{ file.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" @click="cancelDataInvio" class="p-button-text" />
      <Button 
        label="Conferma" 
        icon="pi pi-check" 
        @click="confirmImportRisposta" 
        class="p-button-primary" 
        :disabled="selectedFilesInDialog.length === 0"
      />
    </template>
  </Dialog>

  <Dialog header="Genera Template Annullamenti" v-model:visible="dialogAnnullamenti"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '90vw' }" :modal="true">
    <div class="w-full">
      <DataTable :value="annullamentiItems" v-model:selection="annullamentiSelected" dataKey="id" responsiveLayout="scroll" :rowClass="annullamentiRowClass" :paginator="true" :rows="20"
        :rowsPerPageOptions="[20,50,100]"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown">
        <Column selectionMode="multiple" headerStyle="width: 3rem" />
        <Column field="piva_utente" header="PIVA Utente" :sortable="true"></Column>
        <Column field="cp_utente" header="CP Utente" :sortable="true"></Column>
        <Column field="cp_gestore" header="CP Gestore" :sortable="true"></Column>
        <Column field="code" header="Fornitura" :sortable="true"></Column>
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
        <Column field="agente" header="Agente" :sortable="true"></Column>
        <Column field="cmor_richiesta" header="CMOR Richiesta" :sortable="true"></Column>
        <Column field="piva" header="P.IVA" :sortable="true"></Column>
        <Column field="codfis" header="Cod. Fiscale" :sortable="true"></Column>
        <Column field="email" header="Email" :sortable="true"></Column>
        <Column field="pec" header="PEC" :sortable="true"></Column>
        <Column field="data_invio_risposta" header="Data Invio Risposta" :sortable="true"></Column>
      </DataTable>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogAnnullamenti = false" class="p-button-text" />
      <Button v-if="annullamentiSelected.length > 0" label="Genera Template" icon="pi pi-file-excel" @click="generateTemplateAnnullamenti" class="p-button-success" />
    </template>
  </Dialog>

</template>

<script>

import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import MessaInMoraService from '@/services/ask-management/messa-in-mora-fatture-clienti-service'
import UtilityService from '@/services/ask-management/utility-service'
import { ref, getCurrentInstance, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import Loader from '@/components/Loader.vue'
import moment from 'moment';
import { useToast } from "primevue/usetoast";
import * as XLSX from 'xlsx';
import { watch } from 'vue';

export default {
  components: {
    Loader
  },
  setup() {

    const loader = ref(false);
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    const store = useStore();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const serviceMessaInMora = new MessaInMoraService(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const toast = useToast();
    const activeTabIndex = ref(0);
    const items = ref([]);
    const selectedItems = ref([]);
    const selectedDate = ref([
      moment().startOf('month').toDate(),
      moment().endOf('month').toDate(),
    ]);
    const typesFornitura = ref([
      { name: 'TUTTI' },
      { name: 'POD' },
      { name: 'PDR' },
    ])
    const selectedTypeFornitura = ref(typesFornitura.value[0].name)
    const selectedAgente = ref(null)
    const agenti = ref([])
    const codeFornitura = ref('')
    const expandedRows = ref([]);
    const report = ref()
    const dialogBeforePecSent = ref(false)
    const dialogCheckPecSent = ref(false)
    const dialogConfirmExport = ref(false)
    const exportItemsCount = ref(0)
    const selectedAccordions = ref({})
    const selectedYears = ref({})
    const selectedMonths = ref({})
    const fileInputImportCmorLavorate = ref(null)
    const dialogInfoCmorLavorate = ref(false)
    const infoCmorLavorateData = ref([])
    const infoCmorLavorateType = ref(null)
    const infoCmorLavorateTotalRecords = ref(0)
    const dialogSelectInfoType = ref(false)
    const dialogSelectImportType = ref(false)
    const selectedImportType = ref(null)
    const dialogInsertDataInvio = ref(false)
    const dataInvioValue = ref('')
    const fileInputDialog = ref(null)
    const selectedFilesInDialog = ref([])
    const dialogAnnullamenti = ref(false)
    const annullamentiItems = ref([])
    const annullamentiCount = ref(0)
    const annullamentiSelected = ref([])
    const codUser = ref(localStorage.getItem('cod_user') || sessionStorage.getItem('cod_user') || null)
    const currentUser = ref(null)
    const infoCmorActiveIndexes = ref([])
    const loadingMonthRecords = ref({})

    const extractCodUser = (u) => {
      if (!u) return null;
      if (Array.isArray(u)) {
        const f = u[0] || null;
        return f?.cod_user || f?.id || f?.user_id || null;
      }
      if (u.user && Array.isArray(u.user)) {
        const f = u.user[0] || null;
        return f?.cod_user || f?.id || f?.user_id || null;
      }
      return u.cod_user || u.id || u.user_id || null;
    }

    {
      const raw = store?.state?.auth?.user
      if (raw) {
        try {
          if (typeof raw === 'string') {
            currentUser.value = JSON.parse(atob(raw))
          } else {
            currentUser.value = raw
          }
          if (!codUser.value) {
            codUser.value = extractCodUser(currentUser.value)
          }
        } catch (e) {
          currentUser.value = raw || null
        }
      }
    }

    onMounted(() => {
      getAgenti()
    })

    const getAgenti = () => {
      loader.value = true
      utilityService.getAgenti()
        .then((res) => {
          agenti.value = [{ name: 'TUTTI' }, ...res.items]
          selectedAgente.value = agenti.value[0].name
        }).finally(() => {
          loader.value = false
        })
    }

    const searchData = async () => {
      loader.value = true;
      activeTabIndex.value = null;
      
      let codePod = null;
      let codePdr = null;
      const hasSpecificCode = codeFornitura.value && codeFornitura.value.trim() !== '';
      
      if (hasSpecificCode) {
        const code = codeFornitura.value.trim().toUpperCase();
        if (code.startsWith('IT')) {
          codePod = code;
        } else {
          codePdr = code;
        }
      }
      
      let dates = [];
      if (!hasSpecificCode) {
        if (selectedDate.value[0]) {
          dates[0] = moment(selectedDate.value[0]).format('YYYY-MM-DD');
          dates[1] = moment(selectedDate.value[0]).format('YYYY-MM-DD');
        }
        if (selectedDate.value[1]) {
          dates[1] = moment(selectedDate.value[1]).format('YYYY-MM-DD');
        }
      }
      
      const res = await service.getFornitureInCmor(selectedTypeFornitura.value, dates, 0.1, selectedAgente.value, codePod, codePdr);
      items.value = res.items;
      loader.value = false;
    }


    const generateAndSendFileCmor = () => {
      loader.value = true;
      service.generateAndSendFileCmor(selectedItems.value)
        .then((res) => {
          if (res.items) {
            toast.add({ severity: 'success', summary: 'Successo', detail: 'Template inviato', life: 3000 });
          } else {
            toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore generazione e invio template' });
          }

        }).finally(() => {
          loader.value = false;
        })
    }

    const generateAndSendPecMessaInMora = () => {
      dialogBeforePecSent.value = false
      dialogCheckPecSent.value = false
      loader.value = true;
      
      serviceMessaInMora.generateAndSendPecMessaInMora(selectedItems.value)
        .then((res) => {
          dialogCheckPecSent.value = true
          report.value = res.items
        }).finally(() => {
          loader.value = false;
        })
    }

    const rowClass = (data) => {
      // return [{ 'bg-bluegray-100': !data.pec }];
      return [
        { 'bg-bluegray-100': !data.pec },
        { 'bg-blue-300': data.saldo == 0 && data.data_invio_cmor_template > '' },
        { 'no-select-row': data.existInFileCmort === 1 },
        { 'caso-specifico-consumo': data.caso_specifico_consumo === true }
      ];
    };

    watch(selectedItems, (newVal) => {
      if (!Array.isArray(newVal)) return;
      const filtered = newVal.filter(item => item.existInFileCmort !== 1);
      if (filtered.length !== newVal.length) {
        selectedItems.value = filtered;
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Alcuni elementi non sono selezionabili perché già presenti nei file CMOR', life: 3000 });
      }
    });

    watch(annullamentiSelected, (newVal) => {
      if (!Array.isArray(newVal)) return;
      const filtered = newVal.filter(item => item.gestito !== 1);
      if (filtered.length !== newVal.length) {
        annullamentiSelected.value = filtered;
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Alcuni record risultano già gestiti e non sono selezionabili', life: 3000 });
      }
    });

    const hasResults = computed(() => {
      return Object.keys(items.value).length > 0;
    });

    const hasSelectedAccordions = computed(() => {
      return Object.values(selectedAccordions.value).some(selected => selected === true) ||
             Object.values(selectedYears.value).some(selected => selected === true) ||
             Object.values(selectedMonths.value).some(selected => selected === true);
    });

    const refreshDataTableSelection = () => {
      let selection = [];

      Object.keys(selectedAccordions.value).forEach(type => {
        if (selectedAccordions.value[type] && items.value[type]) {
          Object.keys(items.value[type]).forEach(year => {
            Object.keys(items.value[type][year]).forEach(month => {
              selection = selection.concat(items.value[type][year][month]);
            });
          });
        }
      });

      Object.keys(selectedYears.value).forEach(key => {
        if (selectedYears.value[key]) {
          const [type, year] = key.split('-');
          if (items.value[type] && items.value[type][year]) {
            Object.keys(items.value[type][year]).forEach(month => {
              selection = selection.concat(items.value[type][year][month]);
            });
          }
        }
      });

      Object.keys(selectedMonths.value).forEach(key => {
        if (selectedMonths.value[key]) {
          const [type, year, month] = key.split('-');
          if (items.value[type] && items.value[type][year] && items.value[type][year][month]) {
            selection = selection.concat(items.value[type][year][month]);
          }
        }
      });

      const unique = selection.filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
      selectedItems.value = unique.filter(item => item.existInFileCmort !== 1);
    };

    const updateAccordionSelection = () => {
      selectedAccordions.value = { ...selectedAccordions.value };
      refreshDataTableSelection();
    };

    const updateYearSelection = () => {
      selectedYears.value = { ...selectedYears.value };
      refreshDataTableSelection();
    };

    const updateMonthSelection = () => {
      selectedMonths.value = { ...selectedMonths.value };
      refreshDataTableSelection();
    };

    const exportSelectedResults = () => {
      if (!hasSelectedAccordions.value) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona almeno un elemento da esportare' });
        return;
      }

      let selectedItems = [];
      
      Object.keys(selectedAccordions.value).forEach(type => {
        if (selectedAccordions.value[type] && items.value[type]) {
          Object.keys(items.value[type]).forEach(year => {
            Object.keys(items.value[type][year]).forEach(month => {
              selectedItems = selectedItems.concat(items.value[type][year][month]);
            });
          });
        }
      });

      Object.keys(selectedYears.value).forEach(key => {
        if (selectedYears.value[key]) {
          const [type, year] = key.split('-');
          if (items.value[type] && items.value[type][year]) {
            Object.keys(items.value[type][year]).forEach(month => {
              selectedItems = selectedItems.concat(items.value[type][year][month]);
            });
          }
        }
      });

      Object.keys(selectedMonths.value).forEach(key => {
        if (selectedMonths.value[key]) {
          const [type, year, month] = key.split('-');
          if (items.value[type] && items.value[type][year] && items.value[type][year][month]) {
            selectedItems = selectedItems.concat(items.value[type][year][month]);
          }
        }
      });

      const uniqueItems = selectedItems.filter((item, index, self) => 
        index === self.findIndex(t => t.id === item.id)
      );

      if (uniqueItems.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun elemento trovato da esportare' });
        return;
      }

      exportItemsCount.value = uniqueItems.length;
      dialogConfirmExport.value = true;
    };

    const exportAllResults = () => {
      if (!hasResults.value) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun dato da esportare' });
        return;
      }

      let allItems = [];
      Object.keys(items.value).forEach(type => {
        Object.keys(items.value[type]).forEach(year => {
          Object.keys(items.value[type][year]).forEach(month => {
            allItems = allItems.concat(items.value[type][year][month]);
          });
        });
      });

      if (allItems.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun elemento trovato da esportare' });
        return;
      }

      exportItemsCount.value = allItems.length;
      dialogConfirmExport.value = true;
    };

    const confirmExport = () => {
      dialogConfirmExport.value = false;
      
      let selectedItems = [];
      
      Object.keys(selectedAccordions.value).forEach(type => {
        if (selectedAccordions.value[type] && items.value[type]) {
          Object.keys(items.value[type]).forEach(year => {
            Object.keys(items.value[type][year]).forEach(month => {
              selectedItems = selectedItems.concat(items.value[type][year][month]);
            });
          });
        }
      });

      Object.keys(selectedYears.value).forEach(key => {
        if (selectedYears.value[key]) {
          const [type, year] = key.split('-');
          if (items.value[type] && items.value[type][year]) {
            Object.keys(items.value[type][year]).forEach(month => {
              selectedItems = selectedItems.concat(items.value[type][year][month]);
            });
          }
        }
      });

      Object.keys(selectedMonths.value).forEach(key => {
        if (selectedMonths.value[key]) {
          const [type, year, month] = key.split('-');
          if (items.value[type] && items.value[type][year] && items.value[type][year][month]) {
            selectedItems = selectedItems.concat(items.value[type][year][month]);
          }
        }
      });

      const uniqueItems = selectedItems.filter((item, index, self) => 
        index === self.findIndex(t => t.id === item.id)
      );

      loader.value = true;
      service.generateAndSendFileCmor(uniqueItems)
        .then((res) => {
          if (res.items) {
            toast.add({ 
              severity: 'success', 
              summary: 'Successo', 
              detail: `Template inviato per ${uniqueItems.length} elementi`, 
              life: 5000 
            });
          } else {
            toast.add({ 
              severity: 'warn', 
              summary: 'Attenzione', 
              detail: 'Errore generazione e invio template per export completo' 
            });
          }
        }).finally(() => {
          loader.value = false;
        });
    };


    const exportToXLSX = () => {
      if (!hasResults.value) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun dato da esportare' });
        return;
      }

      let allItems = [];
      Object.keys(items.value).forEach(type => {
        Object.keys(items.value[type]).forEach(year => {
          Object.keys(items.value[type][year]).forEach(month => {
            const itemsWithGroup = items.value[type][year][month].map(item => ({
              tipo_fornitura: type,
              anno: year,
              mese: moment().month(month).locale('it').format('MMMM'),
              ...item,
              data_inizio: formatDate(item.data_inizio),
              data_fine: formatDate(item.data_fine),
              data_invio_messa_in_mora: formatDate(item.data_invio_messa_in_mora),
              data_invio_cmor_template: formatDate(item.data_invio_cmor_template),
              totale_fattura: item.totale_fattura?.toFixed(2) || '0.00',
              pagato: item.pagato?.toFixed(2) || '0.00',
              saldo: item.saldo?.toFixed(2) || '0.00'
            }));
            allItems = allItems.concat(itemsWithGroup);
          });
        });
      });

      if (allItems.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun elemento trovato da esportare' });
        return;
      }

      const wb = XLSX.utils.book_new();
      
      const exportData = allItems.map(item => ({
        'Anno': item.anno,
        'Mese': item.mese,
        'Codice Fornitura': item.code,
        'Cliente': item.cliente,
        'Tot. Fatture': item.totale_fattura,
        'Tot. Pagato': item.pagato,
        'Tot. Saldo': item.saldo,
        'Data Inizio': item.data_inizio,
        'Data Fine': item.data_fine,
        'Data Invio Messa in Mora': item.data_invio_messa_in_mora,
        'Data Invio CMOR': item.data_invio_cmor_template,
        'Rappresentante': item.rappresentante,
        'P.IVA': item.piva,
        'Codice Fiscale': item.codfis,
        'Tipo Cliente': item.type_client,
        'Email': item.email,
        'PEC': item.pec,
        'Agente': item.agente,
        'UDD': item.udd,
        'Nell\'ultimo anno udd con': item.rcus.udd + ' - ' + formatDate(item.rcus.data_fine)
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      
      XLSX.utils.book_append_sheet(wb, ws, 'Forniture CMOR');
      
      const now = moment().format('YYYY-MM-DD_HH-mm-ss');
      const filename = `Forniture_CMOR_${now}.xlsx`;
      
      XLSX.writeFile(wb, filename);
      
      toast.add({
        severity: 'success', 
        summary: 'Successo', 
        detail: `File Excel scaricato: ${allItems.length} elementi`, 
        life: 5000 
      });
    };

    const triggerImportCmorLavorate = () => {
      dialogSelectImportType.value = true;
    };

    const selectImportType = (tipo) => {
      selectedImportType.value = tipo;
      dialogSelectImportType.value = false;
      
      if (tipo === 'risposta') {
        selectedFilesInDialog.value = [];
        dialogInsertDataInvio.value = true;
      } else {
        if (fileInputImportCmorLavorate.value) {
          fileInputImportCmorLavorate.value.value = '';
          fileInputImportCmorLavorate.value.click();
        }
      }
    };

    const cancelDataInvio = () => {
      dialogInsertDataInvio.value = false;
      dataInvioValue.value = '';
      selectedFilesInDialog.value = [];
      selectedImportType.value = null;
    };

    const confirmDataInvio = () => {
      const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!dateRegex.test(dataInvioValue.value)) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Formato data non valido. Usare gg/mm/aaaa', life: 4000 });
        return;
      }

      const parts = dataInvioValue.value.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);

      if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Data non valida. Verifica giorno, mese e anno', life: 4000 });
        return;
      }

      dialogInsertDataInvio.value = false;
      if (fileInputImportCmorLavorate.value) {
        fileInputImportCmorLavorate.value.value = '';
        fileInputImportCmorLavorate.value.click();
      }
    };

    const triggerFileInputDialog = () => {
      if (fileInputDialog.value) {
        fileInputDialog.value.value = '';
        fileInputDialog.value.click();
      }
    };

    const onFileSelectedInDialog = (e) => {
      const files = e.target.files && e.target.files.length > 0 ? Array.from(e.target.files) : [];
      if (!files.length) return;

      const invalidFiles = files.filter(file => !/\.csv$/i.test(file.name));
      if (invalidFiles.length > 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona solo file .csv', life: 4000 });
        return;
      }

      selectedFilesInDialog.value = files;
    };

    const confirmImportRisposta = async () => {
      if (selectedFilesInDialog.value.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona almeno un file', life: 4000 });
        return;
      }

      try {
        loader.value = true;
        dialogInsertDataInvio.value = false;
        
        const { items } = await service.importCmorFiles(selectedFilesInDialog.value, selectedImportType.value, null);
        if (items && items.success) {
          toast.add({ 
            severity: 'success', 
            summary: 'Successo', 
            detail: 'Import risposta completato', 
            life: 5000 
          });
        } else {
          const msg = (items && items.message) ? items.message : 'Import non riuscito';
          toast.add({ severity: 'error', summary: 'Errore', detail: msg, life: 6000 });
        }
      } catch (err) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'import del file', life: 6000 });
      } finally {
        loader.value = false;
        selectedImportType.value = null;
        selectedFilesInDialog.value = [];
      }
    };

    const onFileChangeImportCmorLavorate = async (e) => {
      const files = e.target.files && e.target.files.length > 0 ? Array.from(e.target.files) : [];
      if (!files.length || !selectedImportType.value) {
        selectedImportType.value = null;
        dataInvioValue.value = '';
        return;
      }

      const invalidFiles = files.filter(file => !/\.csv$/i.test(file.name));
      if (invalidFiles.length > 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona solo file .csv', life: 4000 });
        selectedImportType.value = null;
        dataInvioValue.value = '';
        return;
      }

      try {
        loader.value = true;
        const dataInvio = null;
        const { items } = await service.importCmorFiles(files, selectedImportType.value, dataInvio);
        if (items && items.success) {
          toast.add({ 
            severity: 'success', 
            summary: 'Successo', 
            detail: `Import ${selectedImportType.value === 'richiesta' ? 'richiesta' : 'risposta'} completato`, 
            life: 5000 
          });
        } else {
          const msg = (items && items.message) ? items.message : 'Import non riuscito';
          toast.add({ severity: 'error', summary: 'Errore', detail: msg, life: 6000 });
        }
      } catch (err) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'import del file', life: 6000 });
      } finally {
        loader.value = false;
        selectedImportType.value = null;
        dataInvioValue.value = '';
      }
    };

    const openInfoCmorLavorateDialog = () => {
      dialogSelectInfoType.value = true;
    };

    const openAnnullamentiDialog = async () => {
      dialogAnnullamenti.value = true;
      try {
        const raw = store?.state?.auth?.user
        if (raw) {
          if (typeof raw === 'string') {
            currentUser.value = JSON.parse(atob(raw))
          } else {
            currentUser.value = raw
          }
          codUser.value = extractCodUser(currentUser.value) || codUser.value
        } else {
          codUser.value = localStorage.getItem('cod_user') || sessionStorage.getItem('cod_user') || codUser.value
        }
      } catch (_) {
        codUser.value = localStorage.getItem('cod_user') || sessionStorage.getItem('cod_user') || codUser.value
      }
      // eslint-disable-next-line no-console
      loader.value = true;
      try {
        const { items } = await service.getCmorDaAnnullare();
        if (items && items.success) {
          annullamentiItems.value = items.data || [];
          annullamentiCount.value = items.count || 0;
          annullamentiSelected.value = [];
        } else {
          annullamentiItems.value = [];
          annullamentiCount.value = 0;
          toast.add({ severity: 'error', summary: 'Errore', detail: items?.message || 'Errore nel recupero dati', life: 5000 });
        }
      } catch (err) {
        annullamentiItems.value = [];
        annullamentiCount.value = 0;
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante il recupero dei dati', life: 5000 });
      } finally {
        loader.value = false;
      }
    }

    const generateTemplateAnnullamenti = async () => {
      if (!annullamentiSelected.value || annullamentiSelected.value.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona almeno un record', life: 3000 });
        return;
      }

      const pods = annullamentiSelected.value
        .filter(item => item.pod_id)
        .map(item => item.pod_id);
      const pdrs = annullamentiSelected.value
        .filter(item => item.pdr_id)
        .map(item => item.pdr_id);

      if (pods.length === 0 && pdrs.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessun POD/PDR valido selezionato', life: 3000 });
        return;
      }

      try {
        loader.value = true;
      const userId = codUser.value || extractCodUser(currentUser.value) || localStorage.getItem('cod_user') || sessionStorage.getItem('cod_user') || null;
        if (!userId) {
          toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'cod_user non trovato: il file sarà generato senza utente', life: 4000 });
        }
        const ok = await service.generateTemplateAnnullamentoCmor(pods, pdrs, userId);
        if (ok) {
          toast.add({ severity: 'success', summary: 'Successo', detail: 'Template generato', life: 4000 });
        } else {
          toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore generazione template', life: 5000 });
        }
      } finally {
        loader.value = false;
      }
    }

    const annullamentiRowClass = (data) => {
      return [
        { 'no-select-row': data.gestito === 1 },
        { 'annullamenti-gestito': data.gestito === 1 }
      ]
    }

    const selectInfoType = async (tipo) => {
      dialogSelectInfoType.value = false;
      dialogInfoCmorLavorate.value = true;
      loader.value = true;
      infoCmorLavorateType.value = tipo;
      infoCmorActiveIndexes.value = [];
      loadingMonthRecords.value = {};
      
      try {
        const { items: datesResponse } = await service.getInfoCmorLavorateDate(tipo);
        
        if (datesResponse && datesResponse.success) {
          const dates = datesResponse.data || [];
          infoCmorLavorateTotalRecords.value = datesResponse.total_records || 0;
          
          
          infoCmorLavorateData.value = dates.map(dateInfo => ({
            anno: dateInfo.anno,
            mese: dateInfo.mese,
            mese_nome: dateInfo.mese_nome,
            count: dateInfo.count,
            records: [] 
          }));
        } else {
          toast.add({ 
            severity: 'error', 
            summary: 'Errore', 
            detail: datesResponse?.message || 'Errore durante il caricamento delle informazioni', 
            life: 5000 
          });
          infoCmorLavorateData.value = [];
          infoCmorLavorateTotalRecords.value = 0;
        }
      } catch (err) {
        console.error('Errore durante il caricamento delle informazioni:', err);
        toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: 'Errore durante il caricamento delle informazioni', 
          life: 5000 
        });
        infoCmorLavorateData.value = [];
        infoCmorLavorateTotalRecords.value = 0;
      } finally {
        loader.value = false;
      }
    };

    const onInfoCmorTabOpen = async (event) => {
      const index = event.index;
      const monthData = infoCmorLavorateData.value[index];
      
      if (!monthData) return;
      
      const key = `${monthData.anno}-${monthData.mese}`;
      
      if (monthData.records && monthData.records.length > 0) {
        return;
      }
      
      if (loadingMonthRecords.value[key]) {
        return;
      }
      
      loadingMonthRecords.value[key] = true;
      
      try {
        const { items: recordsResponse } = await service.getInfoCmorLavorateRecords(
          infoCmorLavorateType.value,
          monthData.anno,
          monthData.mese
        );
        
        if (recordsResponse && recordsResponse.success) {
          infoCmorLavorateData.value[index].records = recordsResponse.records || [];
        } else {
          toast.add({ 
            severity: 'error', 
            summary: 'Errore', 
            detail: recordsResponse?.message || `Errore durante il caricamento dei record per ${monthData.mese_nome} ${monthData.anno}`, 
            life: 5000 
          });
        }
      } catch (err) {
        console.error(`Errore caricamento record per ${monthData.mese_nome} ${monthData.anno}:`, err);
        toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: `Errore durante il caricamento dei record per ${monthData.mese_nome} ${monthData.anno}`, 
          life: 5000 
        });
      } finally {
        loadingMonthRecords.value[key] = false;
      }
    };


    return {
      loader,
      formatDate,
      filters,
      searchData,
      selectedDate,
      activeTabIndex,
      items,
      selectedItems,
      generateAndSendFileCmor,
      generateAndSendPecMessaInMora,
      selectedTypeFornitura,
      typesFornitura,
      expandedRows,
      rowClass,
      dialogBeforePecSent,
      dialogCheckPecSent,
      report,
      moment,
      selectedAgente,
      agenti,
      codeFornitura,
      hasResults,
      hasSelectedAccordions,
      selectedAccordions,
      selectedYears,
      selectedMonths,
      updateAccordionSelection,
      updateYearSelection,
      updateMonthSelection,
      exportSelectedResults,
      exportAllResults,
      exportToXLSX,
      fileInputImportCmorLavorate,
      triggerImportCmorLavorate,
      onFileChangeImportCmorLavorate,
      dialogConfirmExport,
      exportItemsCount,
      confirmExport,
      dialogInfoCmorLavorate,
      infoCmorLavorateData,
      infoCmorLavorateType,
      infoCmorLavorateTotalRecords,
      openInfoCmorLavorateDialog,
      dialogSelectInfoType,
      selectInfoType,
      dialogSelectImportType,
      selectImportType,
      dialogInsertDataInvio,
      dataInvioValue,
      cancelDataInvio,
      confirmDataInvio,
      fileInputDialog,
      selectedFilesInDialog,
      triggerFileInputDialog,
      onFileSelectedInDialog,
      confirmImportRisposta,
      dialogAnnullamenti,
      annullamentiItems,
      annullamentiCount,
      openAnnullamentiDialog,
      annullamentiSelected,
      generateTemplateAnnullamenti,
      annullamentiRowClass,
      infoCmorActiveIndexes,
      loadingMonthRecords,
      onInfoCmorTabOpen,
    }
  }
}
</script>

<style scoped>
.table-cmor .p-datatable-row-expansion {
  background-color: rgb(248, 248, 248) !important;
}

.table-cmor .p-datatable-row-expansion tr {
  background-color: rgb(248, 248, 248) !important;
}

.btn-selected {
  position: fixed;
  bottom: 60px;
  right: 40px;
  z-index: 2;
}

.search-btn {
  min-width: 150px;
  white-space: nowrap;
}

.export-all-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  height: 2.5rem;
  padding: 0.5rem 1rem;
  margin-left:2rem;
  min-width: 180px;
}

.export-all-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.export-all-btn:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.export-xlsx-btn {
  background: linear-gradient(135deg, #1f7a1f 0%, #28a745 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(31, 122, 31, 0.3);
  height: 2.5rem;
  padding: 0.5rem 1rem;
  margin-left: 2rem;
  min-width: 180px;
}

.export-xlsx-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #155724 0%, #1e7e34 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(31, 122, 31, 0.4);
}

.export-xlsx-btn:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}


:deep(.p-datatable .p-datatable-tbody > tr.no-select-row) .p-checkbox,
:deep(.p-datatable .p-datatable-tbody > tr.no-select-row) .p-radiobutton,
:deep(.p-datatable .p-datatable-tbody > tr.no-select-row) .p-selection-column {
  pointer-events: none;
  opacity: 0.5;
}

:deep(.p-datatable .p-datatable-tbody > tr.annullamenti-gestito) {
  background-color: #84d19a !important;
}

:deep(.p-datatable .p-datatable-tbody > tr.caso-specifico-consumo) {
  background-color: #fef3c7 !important;
}

.import-xlsx-btn {
  background: linear-gradient(135deg, #4a4d7b 0%, #4f41ee 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(31, 122, 31, 0.3);
  height: 2.5rem;
  padding: 0.5rem 1rem;
  margin-left: 2rem;
  min-width: 240px;
  white-space: nowrap;
}

.import-xlsx-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #4a4d7b 0%, #2e1dec 100%);
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(31, 122, 31, 0.3);
}

.import-xlsx-btn:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.info-xlsx-btn {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  height: 2.5rem;
  padding: 0.5rem 1rem;
  margin-left: 2rem;
  min-width: 180px;
  white-space: nowrap;
}

.info-xlsx-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
}

.info-xlsx-btn:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.annullamenti-btn {
  background: linear-gradient(135deg, #dc3545 0%, #bd2130 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  height: 2.5rem;
  padding: 0.5rem 1rem;
  margin-left: 2rem;
  min-width: 250px;
  white-space: nowrap;
}

.annullamenti-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333 0%, #9a1c28 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.annullamenti-btn:disabled {
  background: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

</style>
